import { CommonClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiClientCommon = new CommonClient(defaultAxiosInstance)
